import { styled } from "@mui/material";

const GradientBase = styled("div")`
  width: 100%;
  position: sticky;
  left: 0;
  content: "''";
  height: 89px;
  margin-top: -89px;
  z-index: 3;
  pointer-events: none;
`;

export const TopGradientBar = styled(GradientBase)`
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.palette.background.paper} 5%,
    rgba(255, 255, 255, 0) 100%
  );
  top: 0;
`;

export const BottomGradientBar = styled(GradientBase)`
  background: linear-gradient(
    0deg,
    ${({ theme }) => theme.palette.background.paper} 5%,
    rgba(255, 255, 255, 0) 100%
  );
  bottom: 0;
`;
